<template>
  <div>
    <!-- Authors Table -->
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <!-- Authors Table Card -->
        <ReportTable :loading="loading" :data="tableData" :columns="tableColumns" :currentPage="currentPage"
          :countObjData="countObjData" :perPage="perPage" :optionNationality="optionNationality"
          :optionProgram="optionProgram" :optionMajor="optionMajor" :optionYear="optionYear" @changepage="onChangePage"
          @search="onSearch" :loadBtnExport="loadBtnExport" @exportAlumniReports="exportAlumniReports"
          ></ReportTable>
        <!-- / Authors Table Card -->
      </a-col>

      <!-- / Authors Table Column -->
    </a-row>
    <!-- / Authors Table -->
  </div>
</template>

<script>
// "Authors" table component.
import ReportTable from "./ReportTable";
import _excelReport from "../excel-report/headerexcel.js";

// "Authors" table list of columns and their properties.

const tableColumns = [
  {
    title: "Date of Activity",
    width: 100,
    dataIndex: "engement_activity_detail.date_of_activity",
    scopedSlots: { customRender: "engement_activity_detail.date_of_activity" },
    fixed: "left",
    className: "center-colum column-header-report",
  },
  {
    title: "Activity Name",
    width: 100,
    dataIndex: "engement_activity_detail.name_of_activity",
    scopedSlots: { customRender: "engement_activity_detail.name_of_activity" },
    fixed: "left",
    className: "center-colum column-header-report",
  },
  {
    title: "Student ID",
    dataIndex: "alumni_profile_detail.student_id",
    scopedSlots: { customRender: "alumni_profile_detail.student_id" },
    width: 100,
    fixed: "left",
    className: "center-colum column-header-report",
  },
  {
    title: "Major",
    dataIndex: "alumni_profile_detail.major_detail.name_eng",
    scopedSlots: {
      customRender: "alumni_profile_detail.major_detail.name_eng",
    },
    width: 100,
    fixed: "left",
    className: "center-colum column-header-report",
  },
  {
    title: "Academic Title",
    dataIndex: "academic_title",
    scopedSlots: { customRender: "academic_title" },
    width: 100,
    fixed: "left",
    className: "center-colum column-header-report",
  },
  {
    title: "Title",
    dataIndex: "alumni_title",
    scopedSlots: { customRender: "alumni_title" },
    width: 100,
    fixed: "left",
    className: "center-colum column-header-report",
  },
  {
    title: "Name Surname",
    dataIndex: "alumni_name",
    scopedSlots: { customRender: "alumni_name" },
    width: 100,
    fixed: "left",
    className: "center-colum column-header-report",
  },
  {
    title: "Role and Duty in the activity",
    dataIndex: "role_and_duty_in_the_activity_detail.name_eng",
    scopedSlots: {
      customRender: "role_and_duty_in_the_activity_detail.name_eng",
    },
    className: "center-colum column-header-report-sub",
  },
  {
    title: "Organized By",
    dataIndex: "engement_activity_detail.organized_by",
    scopedSlots: { customRender: "engement_activity_detail.organized_by" },
    className: "center-colum column-header-report-sub",
  },
  {
    title: "Graduate Year",
    dataIndex: "alumni_profile_detail.graduate_year",
    scopedSlots: { customRender: "alumni_profile_detail.graduate_year" },
    className: "center-colum column-header-report-sub",
  },
  {
    title: "Location",
    dataIndex: "engement_activity_detail.location",
    scopedSlots: { customRender: "engement_activity_detail.location" },
    className: "center-colum column-header-report-sub",
  },
  {
    title: "Donation",
    dataIndex: "donation",
    scopedSlots: { customRender: "donation" },
    className: "center-colum column-header-report-sub",
    width: 150,
  },
  {
    title: "Updated On",
    dataIndex: "updated_at",
    scopedSlots: { customRender: "updated_at" },
    className: "center-colum column-header-report-sub",
  },
  // {
  //   title: "Amount Charity",
  //   dataIndex: "amount_charity",
  //   scopedSlots: { customRender: "amount_charity" },
  //   width: 100,
  //   fixed: "left",
  //   className: "center-colum column-header-report",
  // },
  // {
  //   title: "Amount Fee",
  //   dataIndex: "amount_fee",
  //   scopedSlots: { customRender: "amount_fee" },
  //   width: 100,
  //   fixed: "left",
  //   className: "center-colum column-header-report",
  // },
  // {
  //   title: "Amount Sponsorship",
  //   dataIndex: "amount_sponsorship",
  //   scopedSlots: { customRender: "amount_sponsorship" },
  //   width: 100,
  //   fixed: "left",
  //   className: "center-colum column-header-report",
  // },
  // {
  //   title: "Income",
  //   dataIndex: "engement_activity_detail.income",
  //   scopedSlots: { customRender: "engement_activity_detail.income" },
  //   className: "center-colum column-header-report-sub",
  // },
  {
    title: "Action",
    key: "Action",
    fixed: "right",
    width: 100,
    scopedSlots: { customRender: "Action" },
    className: "center-colum column-header-activity",
  },
];

export default {
  components: {
    ReportTable,
  },
  data() {
    return {
      // Associating "Authors" table data with its corresponding property.
      tableData: [],
      // Associating "Authors" table columns with its corresponding property.
      tableColumns: tableColumns,
      loading: false,
      // pagination
      perPage: 10,
      countObjData: 0,
      currentPage: 1,
      offset: 0,
      // option selected
      optionNationality: [],
      optionProgram: [],
      optionMajor: [],
      optionYear: [],
      //
      donationParam : '',
      //
      dataFilter: {},
      // export data : _excelReport
      loadBtnExport: false,
      headExcelAlumniData: _excelReport.reportB,
      dataExcel: [],
    };
  },
  mounted() {
    this.setOptionYear();
    this.getDataOption();
    this.getDataActivity();
  },
  methods: {
    onChangePage(...args) {
      this.currentPage = args[0].currentPage;
      this.offset = args[0].currentPage;
      this.getDataActivity();
    },
    onSearch(...args) {
      this.dataFilter = Object.assign({}, args[0].dataQuery);
      this.currentPage = 1;
      this.offset = 0;
      this.getDataActivity();
    },
    changeFormatDateToFisicalYear(typeDate, yearStart, yearEnd) {
      if (yearStart && yearEnd) {
        if (typeDate == 'Start') {
          return (parseInt(yearStart)).toString() + '-10-01'
        } else {
          if (yearStart != yearEnd) return (parseInt(yearEnd + 1)).toString() + '-09-30'
          else return (parseInt(yearEnd + 1)).toString() + '-09-30'
        }
      } else {
        return ''
      }
    },
    async getDataActivity() {
      this.tableData = [];
      this.loading = true;
      let url = "";
      try {
        if (Object.keys(this.dataFilter).length != 0) {
          switch (this.dataFilter.donation) {//'fee', 'sponsorship', 'charity'
            case 'fee':
            this.donationParam = '&amount_fee__gt=0'
              break;
            case 'sponsorship':
            this.donationParam = '&amount_sponsorship__gt=0'
              break;
            case 'charity':
            this.donationParam = '&amount_charity__gt=0'
              break;
          }
          url = `/student_affair/engagement-record/?limit=${this.perPage}&search=${this.dataFilter.searchText}&offset=${this.offset}${this.donationParam}&alumni_profile__major=${this.dataFilter.major}&engement_activity__date_of_activity__gte=${this.changeFormatDateToFisicalYear('Start', this.dataFilter.fisicalStart, this.dataFilter.fisicalEnd)}&engement_activity__date_of_activity__lte=${this.changeFormatDateToFisicalYear('End', this.dataFilter.fisicalStart, this.dataFilter.fisicalEnd)}&alumni_profile__graduate_year__gte=${this.dataFilter.yearStart}&alumni_profile__graduate_year__lte=${this.dataFilter.yearEnd}&alumni_profile__program_code=${this.dataFilter.program}&alumni_profile__nationality=${this.dataFilter.nationnality}&alumni_profile__membership_id__isnull=${this.dataFilter.member?
            (this.dataFilter.member == "member" ? false : true)
            : ""}`;
        } else {
          url = `/student_affair/engagement-record/?limit=${this.perPage}&offset=${this.offset}`;
        }
        const res = await this.$http.get(url);
        if (res.status === 200) {
          this.tableData = res.data.results.map((item) => ({ ...item }));
          this.countObjData = res.data.count;
          this.offset = 0;
          this.loading = false;
        } else {
          throw { res };
        }
      } catch (error) {
        this.tableData = [];
        this.$notification['error']({
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Failed to connect to the API`),
            ]);
          },
          description:
            `Error ${error.response.status} : /student_affair/alumni-activity/`,
        });
        this.loading = false;
      }
    },
    setOptionYear() {
      this.optionYear = [];
      for (let y = 0; y <= 200; y++) {
        let listY = parseInt(this.moment().format("YYYY") - y);
        this.optionYear.push(listY);
      }
    },
    async getDataOption() {
      const fetchNationality = await this.$http.get(
        `/student_affair/nationality/`
      );
      const fetchProgram = await this.$http.get(
        `/student_affair/program-code/`
      );
      const fetchMajor = await this.$http.get(`/student_affair/major/`);
      Promise.all([fetchNationality, fetchProgram, fetchMajor])
        .then((response) => {
          return Promise.all(response.map((r) => r.data));
        })
        .then(([listA, listB, listC]) => {
          this.optionNationality = listA.map((item) => {
            return {
              id: item.id,
              text: `${item.name_eng}`,
              value: item.id,
            };
          });
          this.optionProgram = listB.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionMajor = listC.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
        })
        .catch((error) => {
          this.$notification['error']({
            message: function (h) {
              return h("div", [
                h("strong", { class: "" }, `Failed to connect to the API`),
              ]);
            },
            description:
              `Error ${error.response.status}`,
          });
        });
    },
    async exportAlumniReports() {
      this.loadBtnExport = true;
      this.dataExcel = [];
      if (this.tableData.length > 0) {
        this.dataExcel = this.tableData.map((item) => ({
          A: item.alumni_profile,
          B: item.id,
          C: `${_excelReport.printFormatData(
            item.alumni_profile_detail.muicaa_member,
            "string",
            ""
          )}`,
          D: `${_excelReport.printFormatData(
            item.alumni_profile_detail.muicaa_steering_committee,
            "string",
            ""
          )}`,
          E: `${_excelReport.printFormatData(
            item.alumni_profile_detail.student_id,
            "string",
            ""
          )}`,
          F: `${_excelReport.printFormatData(
            item.alumni_profile_detail.name_detail.slice().reverse()[0],
            "Obj",
            "academic_title_detail"
          )}`,
          G: `${_excelReport.printFormatData(
            item.alumni_profile_detail.name_detail.slice().reverse()[0],
            "Obj",
            "title_name_detail"
          )}`,
          H: `${_excelReport.printFormatData(
            item.alumni_profile_detail.name_detail.slice().reverse()[0],
            "Obj",
            "eng_first_name"
          )}`,
          I: `${_excelReport.printFormatData(
            item.alumni_profile_detail.name_detail.slice().reverse()[0],
            "Obj",
            "eng_middle_name"
          )}`,
          J: `${_excelReport.printFormatData(
            item.alumni_profile_detail.name_detail.slice().reverse()[0],
            "Obj",
            "eng_last_name"
          )}`,
          K: `${_excelReport.printFormatData(
            item.alumni_profile_detail.major_detail,
            "Obj",
            "name_eng"
          )}`,
          L: `${_excelReport.printFormatData(
            item.engement_activity_detail,
            "Obj",
            "date_of_activity"
          )}`,
          M: `${_excelReport.printFormatData(
            item.engement_activity_detail,
            "Obj",
            "name_of_activity"
          )}`,
          N: `${_excelReport.printFormatData(
            item.role_and_duty_in_the_activity_detail,
            "Obj",
            "name_eng"
          )}`,
          O: `${_excelReport.printFormatData(
            item.engement_activity_detail,
            "Obj",
            "organized_by"
          )}`,
          P: `${_excelReport.printFormatData(
            item.alumni_profile_detail.graduate_year,
            "string",
            ""
          )}`,
          Q: `${_excelReport.printFormatData(
            item.engement_activity_detail,
            "Obj",
            "location"
          )}`,
          R: `${_excelReport.printFormatData(
            item.engement_activity_detail,
            "Obj",
            "donation"
          )}`,
          S: `${_excelReport.printFormatData(
            item.engement_activity_detail,
            "Obj",
            "budget"
          )}`,
          T: `${_excelReport.printFormatData(
            item.engement_activity_detail,
            "Obj",
            "income"
          )}`,
          U: `${_excelReport.printFormatData(
            item.amount_charity,
            "string",
            ""
          )}`,
          V: `${_excelReport.printFormatData(item.amount_fee, "string", "")}`,
          W: `${_excelReport.printFormatData(
            item.amount_sponsorship,
            "string",
            ""
          )}`,
        }));
        // //console.log(this.dataExcel);
        // create excle file
        const wb = this.XLSX.utils.book_new();
        const data = this.XLSX.utils.json_to_sheet(
          this.headExcelAlumniData.concat(this.dataExcel),
          {
            header: _excelReport.mainExcel,
            skipHeader: true,
          }
        );
        this.XLSX.utils.book_append_sheet(wb, data, "List-alumni-reports");
        this.XLSX.writeFile(wb, "Alumni_Reports.xlsx");
        this.loadBtnExport = false;
      } else {
        this.loadBtnExport = false;
        this.$notification['error']({
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Can't export to excel file`),
            ]);
          },
          description:
            `Data table not fond.`,
        });
      }
    },
  },
};
</script>

<style>
.center-colum {
  text-align: center !important;
  font-weight: 700 !important;
}

th.column-header-report {
  background-color: #23355c !important;
  color: #ffffff !important;
}

th.column-header-report-sub {
  background-color: #9bccf5 !important;
  color: #000000 !important;
}
</style>